import { render } from "./MappingTemplateInfoBox.vue?vue&type=template&id=7e13ad75&scoped=true"
const script = {}

import "./MappingTemplateInfoBox.vue?vue&type=style&index=0&id=7e13ad75&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e13ad75"],['__file',"src/app/catalog/mapping-template/components/MappingTemplateInfoBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e13ad75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e13ad75', __exports__)) {
    api.reload('7e13ad75', __exports__)
  }
  
  module.hot.accept("./MappingTemplateInfoBox.vue?vue&type=template&id=7e13ad75&scoped=true", () => {
    api.rerender('7e13ad75', render)
  })

}


export default __exports__